import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingButton } from '@mui/lab';
import { Grid } from '@mui/material';
import { styled } from 'styled-components';
import { ContainedButton, TextButton } from 'styles/styles';

export const QRCodeContainer = styled(Grid)`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
  margin-top: 2rem;
`;

export const ShowCodeButton = styled(TextButton)`
  margin-left: 0.5rem;
  text-transform: none;
  background-color: ${({ theme }) => theme.palette.grey[300]};
  text-decoration: none;
  padding: 0 0.5rem;

  &:hover {
    background-color: ${({ theme }) => theme.palette.grey[400]};
  }
`;

export const CodeContainer = styled.pre`
  background-color: ${({ theme }) => theme.palette.grey[300]};
  padding: 0.5rem;
  border-radius: 4px;
  margin-top: 1rem;
  cursor: pointer;
  text-align: center;
  min-width: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
`;

export const FullWidthContainedButton = styled(ContainedButton)`
  width: 100%;
`;

export const FullWidthLoadingButton = styled(LoadingButton)`
  width: 100%;
`;

export const MfaFooter = styled(Grid)`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.palette.grey[600]};
  margin-top: 1rem;
`;

export const CodeContainerIcon = styled(FontAwesomeIcon)`
  margin-right: 0.5rem;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const SuccessIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.palette.success.main};
`;

export const RecoveryCodesContainer = styled(Grid)`
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  border-radius: 1rem;
  margin: 1rem 0;
  background-color: ${({ theme }) => theme.palette.grey[200]};
`;
